import { createStyles, Theme } from "@material-ui/core"

const PrivacyStyles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "1.5rem auto"
    }
  })

export default PrivacyStyles